import './media-wrapper.scss';
import { Translations } from '../utils';

/**
 * version    1.1
 * class      MediaWrapper
 * classdesc  Component that manages the page media wrapper with video play/pause
 */
export class MediaWrapper {
  constructor(root) {
    this.root = root;
    this.video = root.querySelector('video');
    this.button = root.querySelector('.tcl-video__control');

    if (!this.video) return;

    this.bindEvents();
    this.syncInitialState();
    this.warmUpForIOSSafari();
  }

  bindEvents() {
    // Gestione Hover (Mouse Over / Mouse Out)
    if (this.root.classList.contains('media-wrapper--video-hover-animation')) {
      this.root.addEventListener('mouseenter', () => this.play());
      this.root.addEventListener('mouseleave', () => this.pause());
    }

    // click sul bottone (se presente)
    if (this.button) {
      this.button.addEventListener('click', () => this.toggle());
    }

    // aggiorna UI anche se il video cambia stato da solo
    this.video.addEventListener('play', () => this.setPlayingState());
    this.video.addEventListener('pause', () => this.setPausedState());
    this.video.addEventListener('ended', () => this.setPausedState());
  }

  toggle() {
    if (this.video.paused) {
      this.play();
    } else {
      this.pause();
    }
  }

  play() {
    const playPromise = this.video.play();
    if (playPromise !== undefined) {
      playPromise.then(() => {
        this.setPlayingState();
      }).catch();
    }
  }

  pause() {
    this.video.pause();
    this.setPausedState();
  }

  setPlayingState() {
    this.root.classList.add('is-playing');
    if (this.button) {
      this.button.setAttribute('aria-pressed', 'true');
      this.button.setAttribute(
        'aria-label',
        Translations.getLabel('MEDIA_WRAPPER_PAUSE_VIDEO', {}, 'Metti in pausa il video'),
      );
    }
  }

  setPausedState() {
    this.root.classList.remove('is-playing');
    if (this.button) {
      this.button.setAttribute('aria-pressed', 'false');
      this.button.setAttribute(
        'aria-label',
        Translations.getLabel('MEDIA_WRAPPER_PLAY_VIDEO', {}, 'Riproduci video'),
      );
    }
  }

  syncInitialState() {
    if (!this.video.paused && !this.video.ended) {
      this.setPlayingState();
    } else {
      this.setPausedState();
    }
  }

  warmUpForIOSSafari() {
    // Warm-up solo dove ha senso: video non in autoplay (es. card/thumbnail).
    if (this.video.hasAttribute('autoplay')) return;

    // iOS Safari può ignorare preload e non mostrare il primo frame finché non c'è un tentativo di play.
    // Proviamo a forzare load() e un play() muted (che spesso è consentito), poi mettiamo subito in pausa.
    const ua = window.navigator.userAgent || '';
    const isIOS = /iP(hone|od|ad)/.test(ua);
    const isWebKit = /WebKit/i.test(ua);
    const isCriOS = /CriOS/i.test(ua);
    const isFxiOS = /FxiOS/i.test(ua);
    const isIOSSafari = isIOS && isWebKit && !isCriOS && !isFxiOS;

    if (!this.video.getAttribute('preload')) {
      this.video.setAttribute('preload', 'auto');
    }

    // In ogni caso proviamo a iniziare il download.
    try {
      this.video.load();
    } catch (e) {
      // ignore
    }

    if (!isIOSSafari) return;

    // Tentativo "best effort": se parte, mettiamo in pausa immediatamente.
    // Se viene bloccato, resta comunque il load() fatto sopra.
    const p = this.video.play();
    if (p && typeof p.then === 'function') {
      p.then(() => {
        this.video.pause();
      }).catch(() => {
        // ignore
      });
    }
  }
}
